import { useEvents } from '@hooks/events.hook';
import React, { type PropsWithChildren, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const PageviewTracker: React.FC<PropsWithChildren> = (props) => {
  const { children } = props;

  const { trackPageview } = useEvents();
  const location = useLocation();

  // biome-ignore lint/correctness/useExhaustiveDependencies: any time the location changes, we want to track a pageview
  useEffect(() => {
    trackPageview();
  }, [location, trackPageview]);

  return children;
};
